import { render, staticRenderFns } from "./ModalSocialMediaAccountsEdit.vue?vue&type=template&id=8a3115c6&scoped=true&"
import script from "./ModalSocialMediaAccountsEdit.vue?vue&type=script&lang=ts&"
export * from "./ModalSocialMediaAccountsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSocialMediaAccountsEdit.vue?vue&type=style&index=0&id=8a3115c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3115c6",
  null
  
)

export default component.exports